<template>
  <div :data-theme="'theme_'+theme" :class="['hpCases',theme, theme =='home' ? 'px-10vw reveal':'']">
    <!--  THEME OPTIONS: home/casesInProduct/articlesInProduct/ -->
    <div class="hpcCasesInner" >
        
        <div v-if="theme==='home'" class="hpCasesTitle">{{localize('clinical_cases')}}</div>
        <div v-if="theme==='home'" class="hpSecSub">
            <router-link :to="getMainPageLink" style="color:#fff;">
              {{localize('explore_clinical_cases')}} - <span style="color:#fff;">{{localize('view_all')}}</span>
              <!-- {{mediaChildren}} -- todo> convert or add the "video" to "url" -->
            </router-link>
        </div>

        <!-- {{sectionData}} -->

        <div :class="['caseBoxes',theme]" ref="items">
            <div class="casesScroller" ref="casesScrolledElements">
            <ul :style="getListStyle()">
                <li v-for="(item,index) in pageData" :key="'cases_'+index" :class="['caseBox',theme]">
                    <!-- <a target="_blank" :href="getItemCaseURL(item)"> -->
                    <div @click="clickHandler(item)">
                        
                        <div v-if="showThumb" class="caseImg fadeUpItem" :style="'--index:'+index">
                          <img :src="'https://mis-implants.com/upload/'+item.img">
                          <!-- <img :src="'img/_temp/recwhite.png'"> -->
                        </div>

                        <div v-if="showSummaryFirst==true" class="caseName hpFont1 fadeUpItem" :style="'--addDelay:0.3s;--index:'+index">
                          {{item.subtitle}}
                        </div>

                        <div class="caseBorder" :style="'--addDelay:0.1s;--index:'+index"></div>

                        <div :class="[titleFontCss,'caseTitle','fadeUpItem']" :style="'--addDelay:0.5s;--index:'+index">
                          <span>{{item.title}}</span>
                        </div>    

                        <div v-if="showSummaryFirst==false" class="caseName hpFont1 fadeUpItem" :style="'--addDelay:0.3s;--index:'+index">
                          {{item.subtitle}}
                        </div>

                        <div class="caseView fadeUpItem" :style="'--addDelay:0.7s;--index:'+index">
                            <span class="hpFont1" v-if="item.video"><i class="fal fa-play"></i>{{localize('watch_video')}}</span>          
                            <span class="hpFont1" v-else><i class="fal fa-file"></i>{{localize('view_publication')}}</span>          
                        </div>                        
                    </div>
                    
                    <div class="caseBoxFooter" >
                      <a>View Publication</a>
                    </div>

                </li>        
            </ul>
            </div>
        </div>
        
        <div class="casesPager">
            <sidepager
                @item-change = "onPagerChange"
                :skinMode="0"
                :itemIndex="currentPage" 
                :mobilePagesCount = "5"
                :itemsPerPage="itemsPerPage"
                :items="pageData">
            </sidepager>
        </div>

    </div>    
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import sidepager from "@/views/com/sidepager.vue";
export default {
  components: { sidepager },
  data() {
    return {
        itemsPerPage:4,
        scrWidth:0,
        currentPage:-1,
        activeIndex: 0,
        test:''
    };
  },
  props: {
    sectionData:{},
    showSummaryFirst:
    {
      type: Boolean,
      default: true
    },
    showThumb:
    {
      type: Boolean,
      default: true
    },
    theme: {
      type: String,
      default: 'home'
    },
    titleFontCss:{
      type:String,
      default:'hpFont15'
    }
  },
  beforeDestroy() { 
    var vm = this;
    window.removeEventListener('resize', vm.onResize); 
  },
  mounted() {
    var vm = this;
    this.$nextTick(() => {
      //alert(vm.theme);
      vm.setMediaChildrenToGallery();

      window.addEventListener('resize', vm.onResize); 
      vm.onResize();     

      var scroller = this.$refs.casesScrolledElements;
      scroller.addEventListener("scroll", vm.checkScrollPos, false);

    })
  },
  watch: {
  },
  computed: {
    ...mapGetters(["localeString"]),
      mediaChildren() 
      {
          //filter only the video elements 
          let mediaArr = _.filter(this.pageData,child => child.video && /(vimeo|youtube)/g.test(child.video));
          let index = -1;
          mediaArr.forEach(function (element) 
          { 
            index++;
            element.id = index;           
            element.media_type_id = 5;
            element.url = element.video;//copy the video also to the "url" prop
            element.src = element.video;
            element.image = '';
          });
          return mediaArr;
          //return this.pageData;
          /*
          return _.filter(
              this.pageData,
              child => child.url && /(vimeo|youtube)/g.test(child.url));
              */
      },

    getMainPageLink()
    {
      return this.parsedLocaleString+"/science/research-library?categories=Clinical%20Cases";
      //return this.parsedLocaleString+"/research-and-development/research-library?categories=Clinical%20Cases";
    },    
    parsedLocaleString() {
      return this.localeString.indexOf("-") > -1 ? "/" + this.localeString : "";
    },
    pageData()
    {
        //alert(this.sectionData.items[0].title);
      return this.sectionData.items;
    }

  },
  methods: 
  {
    ...mapActions(["setGalleryIndex", "setGalleryChildren"]),
    getListStyle()
    {    
      //check how many pages with 4 items in each page
      return "--pagesCount:"+Math.ceil(this.pageData.length/4)+
             ";--itemsCount:"+this.pageData.length;
      
    },
    checkScrollPos()
    {
      var vm = this;
      var scroller = this.$refs.casesScrolledElements;
      let scrolledX = scroller.scrollLeft;      
      var scrollerWidth = scroller.getBoundingClientRect().width;
      var scrollerWrapperX = scroller.offsetLeft;      
      var scrolledInnerX = scrolledX - scrollerWrapperX;
      var reveals = scroller.querySelectorAll(".caseBox");    

      for (var i = 0; i < reveals.length; i++) 
      {
            let elOffsetX = reveals[i].offsetLeft;
            let diff = Math.abs(scrolledX-elOffsetX);
            if(this.itemsPerPage>1)
            {
                var isVisible = this.isElementVisible(scroller,reveals[i]);
                if(isVisible){
                  let pageIndexVisible = Math.floor(i/this.itemsPerPage);
                  vm.currentPage = pageIndexVisible;
                }
            }
            else{                
                if(diff<140){ //mobile mode
                    vm.currentPage = i;//this will update the pager buttons//mobile mode
                }
            }
        }
        if(scrolledX<100){
          vm.currentPage=0;
        }
    },       
    isElementVisible(container, element) 
    {
        const containerRect = container.getBoundingClientRect();
        const elementRect = element.getBoundingClientRect();
        const isVisible = 
        (
            (elementRect.left+(containerRect.width/2)) >= containerRect.left &&
            elementRect.right <= containerRect.right
        );
        return isVisible;
    },

    onResize() 
    {
      var winWidth = window.innerWidth;
      this.scrWidth = winWidth;
      if(this.scrWidth<850)
      {
        //change the pager
        this.itemsPerPage = 1;
      }else{
        //change the pager
        this.itemsPerPage = 4;
      }
    },
    onPagerChange(index)
    {
      this.navTo(index);
    },
    navTo(index)
    {
      this.activeIndex = index;      
      var indexOfElement = index * this.itemsPerPage;//itemsInPage;
      //alert("indexOfElement="+indexOfElement);

      let scrollToElement = this.$refs.casesScrolledElements.getElementsByClassName("caseBox")[indexOfElement];

      scrollToElement.scrollIntoView(
      { 
          behavior: 'smooth',
          inline:'start',
          block:'nearest' }
      );      
    },
    initScrollListener() {
        var vm = this;
        let scroller = this.$refs.casesScrolledElements;
        scroller.addEventListener("scroll", vm.onThumbsScroll, false);
    },
    removeScrollListener() 
    {
        var vm = this;
        let scroller = this.$refs.casesScrolledElements;
        if(scroller!=null){
            scroller.removeEventListener("scroll", vm.onThumbsScroll);
        }
    },
    onThumbsScroll() {
        var vm = this;
        if (vm.scrollTimer != -1){clearTimeout(vm.scrollTimer);}                
        vm.scrollTimer = setTimeout(() => {
            vm.onThumbsScrollFinished();
        }, 50);            //500
    },
    onThumbsScrollFinished()
    {
        //Check the scroll position after the scroll has ended
        this.checkScrollPosition();
    },
    checkScrollPosition() {
        var vm=this;
        let scroller = this.$refs.casesScrolledElements;
        let scrolledX = scroller.scrollLeft;
        var reveals = scroller.querySelectorAll(".caseBox");        
        for (var i = 0; i < reveals.length; i++) {

            let diff = Math.abs(scrolledX-reveals[i].offsetLeft);
            //console.log("element:"+i+" diff:"+diff);
            if(diff<140){
                //.scrolledToIndex = i;
                //let itemsPerPage = 1;//on desktop
                //if(this.isMobile){
                    //itemsPerPage=1;//on mobile
                //}            
                //let pageIndex = i;//Math.floor(i);///itemsPerPage);
                //this.$emit('page-scrolled',pageIndex);
                //update the pager buttons
                vm.currentPage = i;//this will update the buttons
                vm.activeIndex = i;//this will update the thumbs
            }
        }
    },         

    setMediaChildrenToGallery() {
        this.$nextTick(function() {
            if (this.mediaChildren && this.mediaChildren.length) {
                this.setGalleryChildren(this.mediaChildren);
            }
        });
    },

    clickHandler(item)
    {
        if (item.video && item.video.length>0) 
        {
            let id = item.id,
            index = _.findIndex(this.mediaChildren, { id });
            this.setGalleryIndex(index);//index ///<<< SETTING THE INDEX WILL SHOW THE POPUP
        } 
        else if (this.isExternalLink(item)) {            
            window.open(item.url, "_blank"); //EXTERNAL LINK
        } 
        else {            
          window.open("https://mis-implants.com/upload/"+item.url, "_blank"); 
            //this.$router.push("upload/"+item.url); //INTERNAL LINK
        }
    },
    isMedia(item) {
        return item.url && /(vimeo|youtube)/g.test(item.url);
    },
    isExternalLink(item) {
        return item.url && /http/.test(item.url);
    },    
    fixHeights()
    {
      var scrW = window.screen.width;
      if(scrW>900)
      {
        var elements = this.$refs.items;
        var elTitles = elements.querySelectorAll('.caseTitle');
        var maxH = 0;
        for (var i = 0; i < elTitles.length; i++){
            var elH = elTitles[i].offsetHeight;
            if(elH>maxH){
              maxH=elH;            
            }
        }
        for (var i = 0; i < elTitles.length; i++){
            elTitles[i].style.height = maxH+"px";
        }
      }

    },
    getUrl(url)
    {
        let temp = caseURL.toLowerCase();
        if(temp.indexOf("http://")==0 || temp.indexOf("https://")==0){
            return url;
        }else{
            return "https://mis-implants.com/upload/"+url;
        }
    },
    getVideo(video)
    {
        return video;
    },    
    getItemCaseURL(item)
    {
        if(item.video)
        {
            return item.video;
        }
        else
        {
            let temp = item.url.toLowerCase();
            if(temp.indexOf("http://")==0 || temp.indexOf("https://")==0){
                return item.url;
            }else{
                return "https://mis-implants.com/upload/"+item.url;
            }
        }

    },
/*     <a target="_blank" :href="getCaseURL(item.url)" class="hpFont1" v-if="item.url">View Publication</a>          
    <a target="_blank" :href="item.video" class="hpFont1" v-if="item.video">
 */    ___getCaseURL(url)
    {
        let temp = url.toLowerCase();
        if(temp.indexOf("http://")==0 || temp.indexOf("https://")==0){
            return url;
        }else{
            return "https://mis-implants.com/upload/"+url;
        }
    },
    getBg()
    {
      return "background-image: url('img/bgCases6.png');";
    }
  }
};
</script>


<style>
    /* THEMES */
    [data-theme="theme_home"] {
      --caseName:#fff;
      --caseTitle:#fff;
      --imgH:7.5vw;
      --imgBorderRadius:0;
      --casesPagerY:-45px;
      --caseBoxBgColor:none;
      --caseBoxBorderRad:0px;
      --caseBoxPadding:0px;
      --caseBoxMinHeight:0px;
      --caseBoxFooterDisplay:none;
      --caseViewDisplay:block;      
    }
    [data-theme="theme_casesInProduct"] {
      --caseName:#202020;
      --caseTitle:#202020;
      --imgH:12vw;
      --imgBorderRadius:20px;
      --casesPagerY:25px;
      --caseBoxBgColor:none;
      --caseBoxBorderRad:0px;
      --caseBoxPadding:0px;
      --caseBoxMinHeight:0px;
      --caseBoxFooterDisplay:none;
      --caseViewDisplay:block;
    }
    [data-theme="theme_articlesInProduct"] {
      --caseName:#ffffff;
      --caseTitle:#a6e2ff;
      --imgH:12vw;
      --imgBorderRadius:20px;
      --casesPagerY:25px;
      --caseBoxBgColor:#2596df;
      --caseBoxBorderRad:20px;
      --caseBoxPadding:24px 30px;
      --caseBoxMinHeight:24vw;
      --caseBoxMinHeight_Mobile:100vw;
      --caseBoxFooterDisplay:block;
      --caseViewDisplay:none;
    }
    .proArticle_TitleFs
    {
        font-size:clamp(18px, 1.2vw, 36px) !important;
    }
</style>

<style scoped>

    /* ------------- Start animations ------------- */
    .hpCases.reveal .caseBox .caseBorder{
        height: 2px;
        width: 0%;
        border-bottom: solid 2px #1074b7;
        padding-bottom: 10px;
        transition: all ease 1.1s;
        transition-delay: calc(var(--addDelay) + var(--index) * 0.2s);        
    }    
    .hpCases.reveal.active .caseBox .caseBorder{
        width: 100%;
    }    
    .hpCases.reveal .caseBox .fadeUpItem{
        opacity: 0;
        transition: all ease 1.1s;
        transition-delay: calc(var(--addDelay) + (var(--index) * 0.2s));
        transform: translateY(10px);
    }
    .hpCases.reveal.active .caseBox .fadeUpItem{
        opacity: 1;
        transform: translateY(0px);
    }


    /* ------------- Start animations ------------- */


    .casesPager
    {
      clear: both;
      margin: auto;
      display: block;
      width: 66px;
      position: relative;
      top: var(--casesPagerY); 
    }
    .px-10vw
    {
        padding-left: 10vw;
        padding-right: 10vw;        
    }
    .hpCases
    {        
        clear: both;
        padding-top: 2vw;
        padding-bottom: 2vw;
    }
    .hpcCasesInner
    {
        background-color: #48494a;
        border-radius: 25px;
        text-align: center;
        margin: auto;   
        height: auto;     
        background-size: cover;
        background-position:  center center;
    }
    .hpCases.casesInProduct .hpcCasesInner,
    .hpCases.articlesInProduct .hpcCasesInner
    {
      background: transparent;
      /* background: #000; */
      border-radius: 0px;
      border: solid 0px #202020;
      padding-bottom: 50px;
    }


    .hpCasesTitle
    {
        clear: both;
        text-align: center;
        width: 100%;
        text-transform: uppercase;
        letter-spacing: -1px !important;
        font-weight: 200 !important;
        font-size: 2.5vw; 
        color: #fff;
        padding-top:4vw;
    }
    .hpCasesBtn
    {
      clear: both;
      padding-top: 30px;
    }
    .hpCasesBtn a span
    {
      cursor: pointer;
      color: #fff;
      border: solid 2px #fff;   
      clear: both;
      width: 100%;
      display: inline;
      font-weight: 300 !important;     
      border-radius: 30px;
      padding: 10px 20px;      
      transition: all ease 0.3s;    
    }
    .hpCasesBtn a span i
    {
      padding-right: 5px;
    }
    .textLink
    {
      position: relative;
    }
    .textLink span:nth-child(2)
    {
      color: #000;
      background-color: #fff;
      position: absolute;
      top: -10px;
      left: 0px;
      clip-path: inset(100% 0 0 0 );
    }
    .textLink:hover span:nth-child(2)
    {
      clip-path: inset(0 0 0 0);
    }


    .caseBoxes.home
    {
        clear: both;
        padding: 3vw 6vw 6vw 6vw;        
    }   
    .caseBoxes.articlesInProduct,
    .caseBoxes.casesInProduct
    {
      clear: both;
      padding: 0;
    }

    .caseBoxes .casesScroller
    {
        /* border: solid 5px red; */
        width: 100%;
        overflow-x: scroll;
        overflow-y: hidden;
        scroll-snap-type: x mandatory;
        -webkit-overflow-scrolling: touch;
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
    }
    .caseBoxes .casesScroller {
        -ms-overflow-style: none;  /* Internet Explorer 10+ */
        scrollbar-width: none;  /* Firefox */
    }
    .caseBoxes .casesScroller::-webkit-scrollbar { 
        display: none;  /* Safari and Chrome */
    }
    .caseBoxes ul
    {
        list-style-type: none;
        display: flex;
        justify-content: space-between;
        padding: 0px;
        gap: 0px;
        column-gap: 20px;
        flex-wrap: wrap;
        
        /* product page case */
        /* width: calc(var(--pagesCount) * 22.5vw); /* divide 90 by 4 items per page = 22.5*/ 
        width: calc(var(--itemsCount) * 22.5vw); /* divide 90 by 4 items per page = 22.5*/
    }
    .caseBoxes.home ul
    {
        /* hp case */
        width: 204vw;
        /* 100-20-12vw = 68vw 68*3 pages = 204 total for the whole scroll size */
    }
    .caseBoxes ul li
    {
        flex: 1;
        cursor: pointer;
        /* padding: 0px 20px; */
        padding: 0px 0px;
        background: var(--caseBoxBgColor);
        border-radius: var(--caseBoxBorderRad);
        padding: var(--caseBoxPadding);
        min-height: var(--caseBoxMinHeight); /* 26vw; */
    }
    .caseBox
    {
        transition: all ease 0.6s;
        transform: translateY(0);
        display: flex; /* check!!! */
        flex-direction: column;/* check!!! */
    }
    .caseBox .caseImg img
    {
        width: 100%;
        height: var(--imgH);
        border-radius: var(--imgBorderRadius);
        object-fit: cover;
        filter: grayscale(100%);
        transition: all ease 0.3s;
        opacity: 0.5;
    }
    .caseBox .caseName
    {        
        text-align: left;
        color: var(--caseName);
        font-weight: 500 !important;
        padding-top: clamp(8px,0.8vw,30px);        
        position: relative;
    }
    .caseTitle
    {
        padding-top: 10px;   
        text-align: left;
    }
    .caseTitle span
    {
      
        text-align: left;
        color: var(--caseTitle);
        font-weight: 500 !important;
        letter-spacing: -1px;
        

/*         overflow: hidden;        
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
 */        /* height: 7vw; */
    }
    .caseView
    {
        /* border-top: solid 2px #0992e0; */
        /* padding-top: 12px; */
        /* margin-top: 12px; */
        width: 100%;
        text-align: left;
        font-weight: 300 !important;
        padding-top: 10px;
        display: var(--caseViewDisplay);
    }    
    .caseBoxes ul li .caseView span
    {
        font-weight: 400 !important;
        color: var(--caseTitle);
        transition: all ease 0.4s;
    }
    .caseBoxes ul li .caseView span i
    {
      padding-right: 5px;
    }
    .caseBoxFooter
    {
      margin-top:auto;
      text-align:left;
      padding-bottom:15px;
      display: var(--caseBoxFooterDisplay);
    }
    .caseBoxFooter a
    {
      border:solid 1px #fff;padding:12px 20px;margin-top:auto;color:#fff;border-radius:30px;
      font-size: 12px;
      font-weight: 400 !important;
    }

    @media (hover: hover) {
      .caseBox:hover .caseImg img
      {
          filter: grayscale(0%);
          opacity: 1;
      }
      .caseBoxes.articlesInProduct ul li:hover
      {
          background: #515151;
      }
      .caseBox:hover
      {    
        /* transform: scale(1.05); */
      }
      .caseBoxes ul li:hover .caseView span
      {
          color: var(--caseTitle);
      }    
    }

    @media screen and (max-width: 815px)
    {
      .hpCases        {padding: 0 0 0 0;}
      .hpcCasesInner  {border-radius: 0px;padding:6vw 0px;}
      .hpCasesTitle   {font-size: 30px;padding: 30px 0px 0px 0px;}   
      .caseBoxes      {padding: 8vw 15vw 6vw 15vw;} 
      
      .__caseBoxes ul   {display: block;}
      .__caseBox        {padding-bottom: 18px;}
      .__caseView       {padding-top: 2px;margin-bottom: 20px;}
      .__caseTitle      {height:auto;}
      
      .caseBoxes ul
      {
        /* width: 840vw; /* 12 items * 70vw */ 
        width: 350vw; /* 5 items * 70vw */
      }
      .caseBoxes ul li{
          -webkit-box-flex: 1;
          -ms-flex: 1;
          flex: 1;
          cursor: pointer;
          padding: 0 2vw;
          scroll-snap-align: center;
          min-height: var(--caseBoxMinHeight_Mobile); /* 26vw; */
      }      
      .caseBoxes ul li:nth-child(n+6){
        display: none;
      }      

      .caseBox .caseImg img{
          height: 38vw;
      }      
      .casesPager{
        top: 0px;      
        width: 100px;
        /* display: none; */
      }      
      .caseBox.articlesInProduct      
      {
        padding: 5vw 5vw;
      }
    }


    @media only screen and (min-width:2000px)
    {
      .casesPager{
          top: initial;
          bottom: 3vw;
      }      
    }
</style>
